import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  constructor(private http: HttpClient) { }
  // private baseUrl = 'https://globalsources-erp-staging-24532743.dev.odoo.com/odoo/get';
  // private baseUrl = 'https://globalsources-erp.odoo.com/odoo/get';
  private baseUrl = environment.apiUrl + '/get';

  getCountries(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    return this.http.post(this.baseUrl + '/countries', body);
    // return this.http.post('/odoo/get/countries', body);
  }

  // Get country by ID
  getCountryById(id: number): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: { id }
    };
    return this.http.post(this.baseUrl + '/countries', body);
    // return this.http.post('odoo/get/countries', body);
  }

  getStates(CountryID: number): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: { CountryID: CountryID }
    };
    return this.http.post(this.baseUrl + '/states', body);
    //  return this.http.post('/odoo/get/states', body);
  }

  // Get country by ID
  getStateById(id: number): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: { id }
    };
    return this.http.post(this.baseUrl + '/states', body);
    // return this.http.post('/odoo/get/states', body);
  }

  getTitles(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    return this.http.post(this.baseUrl + '/titles', body);
    // return this.http.post('/odoo/get/titles', body);
  }

  // Get country by ID
  getTitleByName(Name: number): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: { Name }
    };
    return this.http.post(this.baseUrl + '/titles', body);
    // return this.http.post('/odoo/get/titles', body);
  }

  getTags(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    return this.http.post(this.baseUrl + '/tags', body);
    // return this.http.post('/odoo/get/titles', body);
  }
}
